module.exports = __webpack_public_path__ + "static/logo1-2f0a086c8c3fa08d495542dee2cf943e.jpg";